import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[_c(VCard,[_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"small":"","color":"primary","to":{name : 'NewVotingSubscriptionView'}}},[_vm._v("New Subscription")])],1),_c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.subscriptions},scopedSlots:_vm._u([{key:"body",fn:function({items}){return [_c('tbody',_vm._l((items),function(item){return _c('tr',{key:item.id})}),0)]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }